module.exports = __webpack_public_path__ + "img/IMG_0204-15_L_BlackMatted_MockedUp.6a8d21bc.jpg";